export const REACT_APP_GOOGLE_MAPS_KEY =
  "AIzaSyBNrFogdWRf7t8epSm118cQvxwGWyRlupU";
